/* ================================================== */
/* REVEAL
/* ================================================== */

$(document).ready(function() {
	ScrollTrigger.batch('[data-reveal]', {
		once: true,
		onEnter: function(batch) {
			gsap.to(batch, { opacity: 1, y: 0, stagger: 0.4 });
		},
		// markers: true
	});

	$(window).resize();
});